<script lang="ts" setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import { Carousel } from '@ark-ui/vue/carousel';
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const { data: imgList } = useAsyncData(
  'home:banner',
  () => $fetch('/operator/getOperatorList', { method: 'post', data: { operateType: 2 } }),
);

// 默认值需要使用 -1 否则 Carousel.Indicator 渲染不正常
const index = ref(-1);

// 在 setup 函数中声明一个 ref 变量来存储定时器
let timer: ReturnType<typeof setInterval>;

// 创建一个函数来自动切换幻灯片
function autoPlay() {
  clearInterval(timer);
  timer = setInterval(() => {
    index.value = (index.value + 1) % imgList.value.length; // 自增索引并确保在图像数组的长度内循环
  }, 3000); // 设置轮播间隔时间（单位：毫秒）
}

watch(index, () => {
  autoPlay();
});

// 在组件挂载时启动自动播放
onMounted(() => {
  index.value = 0;
  autoPlay();
});

// 在组件卸载时清除定时器
onUnmounted(() => {
  clearInterval(timer);
});
</script>

<template>
  <section class="h-400 w-880 rounded-6 shadow-[0_1px_6px_0_rgba(0,0,0,0.04)]">
    <Carousel.Root id="page-tempalte3-carousel" class="relative overflow-x-hidden" loop v-model:index="index" v-if="imgList?.length">
      <Carousel.Viewport>
        <Carousel.ItemGroup>
          <Carousel.Item v-for="(item, idx) in imgList" :key="idx" :index="idx">
            <a :href="item.jumpUrl" target="_blank" :aria-label="`${$t('home.common.carousel.jumpToUrl', { url: item.jumpUrl }) }`">
              <img :src="item.picUrl" :alt="item.operateName" class="h-400 w-full rounded-6 object-cover">
            </a>
          </Carousel.Item>
        </Carousel.ItemGroup>
      </Carousel.Viewport>
      <Carousel.IndicatorGroup class="absolute bottom-24 left-50% z-1 mx-auto flex translate-x--50% gap-x-8">
        <Carousel.Indicator v-for="(_, idx) in imgList" :key="idx" :index="idx" class="h-4 w-32 rounded-2 bg-[rgb(0,0,0,0.1)]" :aria-label="`${$t('home.common.carousel.changeTo', { index: idx + 1 }) }`" @click="index = idx">
          <div class="h-full w-0 rounded-2 bg-black" :class="[ idx === index ? 'w-full transition-width duration-3000 transition-ease-linear' : '']"></div>
        </Carousel.Indicator>
      </carousel.indicatorgroup>
    </Carousel.Root>
  </section>
</template>

<style lang="scss" scoped>
</style>
